// ui/admin-ui/src/api.js
const API_BASE = "/api";

/**
 * Load token from storage
 */
let authToken = localStorage.getItem("authToken");

// ---------------- AUTH ----------------
export async function login(username, password) {
  const res = await fetch(`${API_BASE}/login`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify({ username, password })
  });

  if (!res.ok) {
    throw new Error("Invalid credentials");
  }

  const data = await res.json();
  authToken = data.token;
  localStorage.setItem("authToken", authToken);

  return true;
}

export function logout() {
  authToken = null;
  localStorage.removeItem("authToken");
}

// ---------------- HELPERS ----------------
function authHeaders() {
  if (!authToken) {
    throw new Error("Not authenticated");
  }

  return {
    "Content-Type": "application/json",
    Authorization: `Bearer ${authToken}`
  };
}

function handleAuthFailure(res) {
  if (res.status === 401) {
    logout();
    throw new Error("Session expired");
  }
}

// ---------------- CONTROL (MULTI SIMULATOR) ----------------

export async function startSimulation({
  matchId,
  interval,
  mode,
  target,
  pushMode = "stream"
}) {
  const res = await fetch(`${API_BASE}/start`, {
    method: "POST",
    headers: authHeaders(),
    body: JSON.stringify({
      matchId,
      interval,
      mode,
      target,
      pushMode
    })
  });

  handleAuthFailure(res);

  if (!res.ok) {
    let message = "Failed to start simulation";

    try {
      const err = await res.json();
      message = err.error || message;
    } catch {}

    throw new Error(message);
  }

  return res.json();
}


/**
 * PAUSE ONE SIMULATOR
 */
export async function pauseSimulation(simulatorId) {
  const res = await fetch(`${API_BASE}/pause`, {
    method: "POST",
    headers: authHeaders(),
    body: JSON.stringify({ simulatorId })
  });

  handleAuthFailure(res);

  if (!res.ok) {
    throw new Error("Failed to pause simulation");
  }
}

/**
 * RESUME ONE SIMULATOR
 */
export async function resumeSimulation(simulatorId) {
  const res = await fetch(`${API_BASE}/resume`, {
    method: "POST",
    headers: authHeaders(),
    body: JSON.stringify({ simulatorId })
  });

  handleAuthFailure(res);

  if (!res.ok) {
    throw new Error("Failed to resume simulation");
  }
}

/**
 * STOP ONE SIMULATOR
 */
export async function stopSimulation(simulatorId) {
  const res = await fetch(`${API_BASE}/stop`, {
    method: "POST",
    headers: authHeaders(),
    body: JSON.stringify({ simulatorId })
  });

  handleAuthFailure(res);

  if (!res.ok) {
    throw new Error("Failed to stop simulation");
  }
}

// ---------------- STATUS ----------------

/**
 * Returns:
 * {
 *   simulators: [
 *     {
 *       simulatorId,
 *       matchId,
 *       mode,
 *       target,
 *       pushMode,
 *       paused,
 *       running,
 *       currentEventIndex,
 *       totalEvents
 *     }
 *   ]
 * }
 */
export async function getStatus() {
  if (!authToken) {
  return { simulators: [] };
}


  const res = await fetch(`${API_BASE}/status`, {
    headers: {
  ...authHeaders(),
  "Content-Type": "application/json"
}

  });

  if (res.status === 401) {
    logout();
    return null;
  }

  return res.json();
}
